import React, { useEffect, useContext, useState } from 'react';
import { Link ,useNavigate } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import axios from 'axios';
import {cleanStr,cleanPass} from '../../comfunc.js';
import {strEncode,strDecode} from '../../encrpt.js';
import DataTable from 'react-data-table-component';
import DatePicker from "react-datepicker"; // Ensure you install react-datepicker
import '../Raportee/datatable.css';
import {API_BASE_URL} from "../../apiConfig.jsx";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

function Data() {
	const [expandedIndex, setExpandedIndex] = useState(null);
    const [componentData, setComponentData] = useState({}); // index: data
    const navigate = useNavigate();
	useEffect(() => {
		const authToken = localStorage.getItem("authToken");

		if (!authToken) {
			localStorage.removeItem("user"); // Clear user data
			navigate(""); // Ensure correct redirection path
		}
	}, [navigate]);
	const [data, setData] = useState([]);	
	const [columns, setColumns] = useState([]);
	const [tabledata, settableData] = useState([]);	
	const [headerscols, setHeaders] = useState([]);
	const [headingl1, setModalheadingl1] = useState(null);
	const [accordionid, setaccordionid] = useState(null);
	const [headingid, setModalheadingid] = useState(null);
	const [modalData, setModalData] = useState([]);
	// State for form fields
	
	const [formData, setFormData] = useState(modalData.map(row => ({ ...row, dateValue: row.date || null })));
	  const customStyles = {
		headCells: {
		  style: {
			color:"white",
			background:"black",
			whiteSpace: "normal",
			wordBreak: "break-word",
			overflowWrap: "break-word",
			textAlign: "center",
			wrap :true
		  },
		}
	  }; 
	  const maxLength = headerscols.length;
      const formattedColumns = Object.keys(formData[0] || {}).map((col) => {
	  // Determine header display name from headerscols or fallback to cleaned name
	  const displayName = col.includes("col_") ? headerscols[maxLength - 1]?.[col] || col : col.replace(/_/g, " ");
	  
		return {
		  name: displayName,
		  selector: row => row[col],
		  sortable: true,
		  cell: (row, index) => {
			  // Ensure row[col] exists and is a valid string before applying regex
			  const spanRegex = /<span[^>]*>(.*?)<\/span>/i;
			  const cellValue = row[col] ? row[col].toString() : ""; // Convert to string to avoid errors
			  const match = cellValue.match(spanRegex);
			  return match ? <div dangerouslySetInnerHTML={{ __html: cellValue }} /> : cellValue;
			
		  } // Fetch sub-header from the previous row dynamically
		};
	  });
 
	const formatted_Columns = formattedColumns.slice(1); // Removes the first column
	// Create DataTable with sub-headers properly displayed
const dataTableColumns = formatted_Columns.map((col) => ({
	...col,
	name: (
	  <div>		
		<div>{col.name}</div>
	  </div>
	)
  }));
	 
  	 useEffect(() => {
		axios.post(`${API_BASE_URL}/api/getresultcomponent`, { t: strEncode('pmis_result_component_master')},{ headers: { 'Content-Type': 'application/json' } }) 
          .then( (res) => {
            //console.log("res",res.data)
            setData(res.data);
          }).catch( (error) => { console.log(error); });     
    }, []);

	useEffect(() => {
		if (modalData.length > 0) { // Ensure modalData contains valid entries
			setFormData(modalData.filter(row => Object.values(row).some(value => value !== "" && value !== null && value !== undefined)));
		}
	}, [modalData]);
	useEffect(() => {
		if (modalData.length > 0) { 
			// Ensure modalData contains valid entries by merging all objects
			const mergedFormData = modalData.flatMap(obj => obj); // Flatten nested arrays if needed	
			setFormData(mergedFormData.filter(row => 
				Object.values(row).some(value => value !== "" && value !== null && value !== undefined)
			));
		}
	}, [modalData]);
   
	const handleToggle = async (index, id) => {
		
		axios.post(`${API_BASE_URL}/api/getresultcomponentdata`, { t: strEncode('pmis_result_indicator_master'),indicatorid : strEncode(id)},{ headers: { 'Content-Type': 'application/json' } }) 
		.then( (res) => {
		  //console.log("subcomponent",res.data)
		  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_result_master_planning_cols'),whrc : strEncode("component_id = "+id+"")},{ headers: { 'Content-Type': 'application/json' } }) 
		.then( (colsval) => {	  
		  //console.log("colsval",colsval.data)
	  const mergedModalData = [...colsval.data, ...res.data];
	  
	  setHeaders(colsval.data); // Set headers separately if needed
	  setModalData(res.data); // Store merged header + modal data
	   setaccordionid(id)
	  })
		}).catch( (error) => { console.log(error); });
		
	  };


	  const [activeAccordion, setActiveAccordion] = useState(null);
const [activeNestedAccordion, setActiveNestedAccordion] = useState(null);
const [nestedData, setNestedData] = useState({});
const [loading, setLoading] = useState(null);
const [loadingNested, setLoadingNested] = useState(null);

const handleAccordionToggle = async (index, id) => {
  setActiveAccordion(prev => (prev === index ? null : index));  // Toggle the clicked section

  if (!componentData[index]) {
    setLoading(index);
    try {
      const res = await axios.post(`${API_BASE_URL}/api/getresultcomponentdata`, {
        t: strEncode('pmis_result_indicator_master'),
        indicatorid: strEncode(id)
      }, { headers: { 'Content-Type': 'application/json' } });

      setComponentData(prev => ({
        ...prev,
        [index]: res.data  // Store only for clicked index
      }));

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(null);
    }
  }
};

const handleNestedAccordionToggle = async (indexsub, id) => {
  setActiveNestedAccordion(prev => (prev === indexsub ? null : indexsub));  // Ensures only one sub-section opens

  if (!nestedData[indexsub]) {
    setLoadingNested(indexsub);
    try {
      const response = await axios.post(`${API_BASE_URL}/api/custom/selectall`, {
        t: strEncode('pmis_result_master_planning_cols'),
        whrc: strEncode(`component_id = ${id}`)
      }, { headers: { 'Content-Type': 'application/json' } });

      setNestedData(prev => ({
        ...prev,
        [indexsub]: response.data  // Store data for specific nested section
      }));

    } catch (error) {
      console.error("Error fetching nested data:", error);
    } finally {
      setLoadingNested(null);
    }
  }
};
	  const closeModal = () => {
		setModalheadingid("");
	   }
	

	return (
		<div>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/dashboard/v1">Home</Link></li>
				<li className="breadcrumb-item"><Link to="/dashboard/blank">Raportee</Link></li>
				<li className="breadcrumb-item active">D’atteinte des résultats du Projet</li>
			</ol>
			<h1 className="page-header">Présentation du niveau d’atteinte des résultats du Projet</h1>
			<Panel>
				<PanelHeader>Présentation du niveau d’atteinte des résultats du Projet</PanelHeader>
				<PanelBody>
				<div className="col-xl-12">
				{data.map((item, index) => (
					<div className="accordion" id="accordion">
						<div className="accordion-item border-0">
							<div className="accordion-header" id={"heading"+index}>
								<button className="accordion-button bg-gray-900 text-white px-3 py-10px pointer-cursor" type="button" data-bs-toggle="collapse" 
								data-bs-target={"#collapse"+index}>
									<i className="fa fa-circle fa-fw text-blue me-2 fs-8px"></i> {item.pdo}
								</button>
							</div>
						    <div id={"collapse"+index} className="accordion-collapse collapse" data-bs-parent="#accordion" style={{marginBottom:"2px"}}>
							<div className="accordion-body bg-blue-800 text-white">
							<div className="col-xl-12">
							{item.component.map((items, indexsub) => (
								<div className="accordion" id={"accordion1_" + indexsub}>
									<div className="accordion-item border-0">
									<div className="accordion-header" id={"heading_l3_" + indexsub}>
										<button
										className="accordion-button bg-blue-900 text-white px-3 py-10px pointer-cursor"
										onClick={() => handleToggle(indexsub, items.id)}
										type="button"
										data-bs-toggle="collapse"
										data-bs-target={"#collapse_l3_" + indexsub + "_" + String(items.component).replace(/\s/g, '')} // Append level_3 for uniqueness
										>
										<i className="fa fa-circle fa-fw text-blue me-2 fs-8px"></i> {items.component}
										</button>
									</div>
									<div
									  
										id={"collapse_l3_" + indexsub + "_" + String(items.component).replace(/\s/g, '')} // Unique collapse ID
										className={items.id === accordionid ? "accordion-collapse" : "accordion-collapse collapse"}
										data-bs-parent={"#accordion1_" + indexsub} >
									    
										<div className="accordion-body bg-blue-800 text-white">
										    <div className="table-responsive">
                                         
											<DataTable 
									 columns={dataTableColumns} 
									 data={formData} 
									 pagination 						 
									 className="datatable-header"
									 customStyles={customStyles}
									></DataTable>
							

													
							</div>	
										</div>
									</div>
									</div>
								</div>
							))}

           				    </div>							 	
						    </div>
						    </div>
						</div>					
					</div>
					))}	
				</div>
					
				</PanelBody>
			</Panel>
			
		</div>
	)
}

export default Data;